import React from "react";
import Image from "react-bootstrap/Image";
// import DeletePopup from "../../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import { NavLink } from "react-router-dom";

export const NominationTableBody = ({
  id,
  restaurantImage,
  restaurantName,
  phoneNumber,
  address,
  place,
  restaurantType,
  viewIndex,
  nomination,
  deleteOnClick,
  registeredToggle,
  registeredToggleCss,
  location,
  city,
  reviewRateing,
  reviewTotalCount,
  reviewRateingData,
}) => {
  return (
    <React.Fragment>
      <tbody>
        <tr
          className="super_admin_all_users_table_body super-admin-main-nominations"
          style={{ minHeight: "130px" }}
        >
          {/* <td style={{ width: "10%" }} className="position-relative">
            <div className="super-admin-nominations-table-body-box">
              <div
                className="super-admin-nominations-table-body-boxone position-absolute"
                style={{ top: "-8vh" }}
              >
                <div className="super-admin-nominations-imageBox border-0">
                  <Image
                    fluid
                    src={restaurantImage}
                    alt={`${restaurantName}`}
                    title={`${restaurantName}`}
                    className="img-thumbnail"
                  />
                </div>
                <div className="f12-500 mt-1 text-break">{id}</div>
              </div>
            </div>
          </td> */}
          <td style={{ width: "17%" }}>
            <div className="f12-500">{restaurantName}</div>
            <hr
              className="mb-0 mt-0 w-25 ml-0"
              style={{ border: "none", borderTop: "2px solid #F85032" }}
            />
            <div className="f12-500 mb-1 mt-2 d-flex align-items-center">
              <i
                className="fa fa-star mr-1"
                style={{ color: "#FEC32D", fontSize: 20 }}
                aria-hidden="true"
              ></i>

              {reviewRateing}
              <p className="f10-500 ml-1">
                {" "}
                ({reviewTotalCount} <span className="f10-400">reviews</span>)
              </p>
            </div>
          </td>
          {/* <td style={{ width: "13%" }}>
            <div className="f11-400">{phoneNumber}</div>
          </td> */}
          <td style={{ width: "30%" }}>
            <p className="f10-400 mb-2">{address}</p>
            <p className="f9-500 enEllips">
              Google Place ID: <span className="text-gray">{place}</span>
            </p>
          </td>
          {/* <td style={{ width: "15%" }}>
            <div className="f11-400 text-break">{restaurantType}</div>
          </td> */}
          <td style={{ width: "10%" }}>
            <div className="f11-400 text-break">{city}</div>
          </td>
          <td style={{ width: "12%" }}>
            <div className="f11-400 text-break">{location}</div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="f11-400">{nomination}</div>
          </td>
          <td style={{ width: "8%" }}>
            <div className="mt-2 d-flex align-items-center">
              {registeredToggle}
            </div>
          </td>
          <td style={{ width: "8%" }}>
            <div className="row">
              <div className="col-4">
                <NavLink
                  to={`/superadminviewnominations/${viewIndex}`}
                  className="enIconBtn"
                  style={{ border: "1px solid #EF401B" }}
                >
                  <Image
                    src={require("../../../../../assets/images/UserManagement/eye.svg")}
                    alt="View"
                    title="View Icon"
                    fluid
                  />
                </NavLink>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
